import React from "react";
import { Navigate, useLocation } from "react-router-dom";

 
export const ProtectedRoutes = ({ element }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/Login" replace />;
  }

  return element;
};

 
export const PublicRoute = ({ element }) => {
  const token = localStorage.getItem("token");

  if (token) {
    return <Navigate to="/" replace />;
  }

  return element;
};

export const PaymentGuard = ({ children }) => {
  const location = useLocation();

  // Normalize path (remove duplicate slashes)
  const currentPath = location.pathname.replace(/\/+/g, "/");
  const currentDomain = window.location.hostname;

  // 🚫 Block rule — deny this exact combination
const isDenied =
    currentDomain === "bite.sortstring.com" &&
    ["/student/fee-payment", "/student/payment"].includes(currentPath);

  if (isDenied) {
    // ✅ Redirect immediately to invalid page
    return <Navigate to="/invalid-payment-link" replace />;
  }

  // ✅ Otherwise, render the intended component
  return children;
};